import { SortDescriptor } from '@progress/kendo-data-query/dist/npm/sort-descriptor';
import { GridColumnProps } from '@progress/kendo-vue-grid';
import { inject } from 'inversify';

import { service } from '@/decorators/service';
import { SignalrListener } from '@/decorators/signalr';
import { TableStore } from '@/stores/TableStore';
import { IFilterDescriptor } from '~/FilterDescriptor';
import { ITable } from '~/ITable';

@SignalrListener
@service(TableManager)
export class TableManager {
  @inject(TableStore) protected tableStore: TableStore;

  get getTables() {
    return this.tableStore.all();
  }

  setTables(tables: ITable[]) {
    this.tableStore.set(tables);
  }

  updateTables(tables: ITable[]) {
    this.tableStore.update(...tables);
  }

  updateTable(table: ITable) {
    this.tableStore.update(table);
  }

  findTable(id?: string) {
    return this.tableStore.find(id);
  }

  removeTable(id: string) {
    this.tableStore.remove(id);
  }

  updateTableFilter(tableId: string, filters: IFilterDescriptor[]) {
    const table = this.tableStore.find(tableId);
    if (!table || !table.id) return;
    this.tableStore.update({ ...table, filters });
  }

  updateTableSort(tableId: string, sort: SortDescriptor[]) {
    const table = this.tableStore.find(tableId);
    if (!table || !table.id) return;
    this.tableStore.update({ ...table, sort });
  }

  updateTableColumns(tableId: string, columns: GridColumnProps[]) {
    const table = this.tableStore.find(tableId);
    if (!table || !table.id) return;
    this.tableStore.update({ ...table, columns });
  }
}
